import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

export interface CustomDetails {
  title?: string
  children: React.ReactNode
}

export const CustomDetails = ({ title, children }: CustomDetails) => {
  const Container = ({ children: containerChildren }: { children: React.ReactNode }) => (
    <Box width="full" justifyContent="flexStart" alignItems="flexStart" gap="s8">
      {!!title ? (
        <>
          <Text.Header2 color="grey1000">{title}</Text.Header2>
          {containerChildren}
        </>
      ) : (
        <>{containerChildren}</>
      )}
    </Box>
  )
  return <Container>{children}</Container>
}
